import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { TwitterCommentTemplate } from './variants/TwitterComment'
import { TwitterSlideTemplate } from './variants/TwitterSlide'

const commentVariant = {
  ...productRowVariantForPath('twitter', 2),
  Template: TwitterCommentTemplate,
} as const satisfies RowVariantDefinition

const slideVariant = {
  ...productRowVariantForPath('twitter', 3),
  Template: TwitterSlideTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('twitter')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [commentVariant, slideVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [commentVariant, slideVariant],
    fallback: productRows.submsges.fallback,
  },
})
